"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.START_TIME = exports.LIMIT = void 0;
const HOURLY_LIMIT = 24 * 7;
const DAILY_LIMIT = 3000;
const LIMIT = {
  hour: HOURLY_LIMIT,
  day: DAILY_LIMIT
};
exports.LIMIT = LIMIT;
const START_TIME = new Date('2015-12-09').getTime();
exports.START_TIME = START_TIME;